import { render, staticRenderFns } from "./MediacontactPartnerCategoryForm.vue?vue&type=template&id=540fa4d0"
import script from "./MediacontactPartnerCategoryForm.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports